var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4693 7.27031H12.2037C12.1318 7.27031 12.0631 7.30156 12.0146 7.35625L8.59432 11.2984V2.5C8.59432 2.43125 8.53807 2.375 8.46932 2.375H7.53182C7.46307 2.375 7.40682 2.43125 7.40682 2.5V11.2984L3.98651 7.35625C3.93963 7.30156 3.87088 7.27031 3.79744 7.27031H2.53182C2.42557 7.27031 2.36776 7.39687 2.43807 7.47656L7.62401 13.4531C7.67088 13.5072 7.72884 13.5506 7.79394 13.5803C7.85905 13.61 7.92978 13.6254 8.00135 13.6254C8.07292 13.6254 8.14365 13.61 8.20876 13.5803C8.27386 13.5506 8.33182 13.5072 8.37869 13.4531L13.5631 7.47656C13.6334 7.39531 13.5756 7.27031 13.4693 7.27031Z",
    fill: "#E61F37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2);
export default __webpack_public_path__ + "static/media/ArrowDown2.25c95b5db46c40f99194e4dec2eb12e3.svg";
export { ForwardRef as ReactComponent };